export default __webpack_public_path__ + "static/media/Montserrat-Regular.2a2d37bf.ttf";